var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobilePlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus-light",
    transform: "translate(0 -0.1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_648",
    "data-name": "Rectangle 648",
    width: 15,
    height: 15,
    transform: "translate(0 0.1)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_132",
    "data-name": "Line 132",
    d: "M.878-4.589H-5.773C-5.9-4.589-6-4.9-6-5.295S-5.9-6-5.773-6H.878C1-6,1.1-5.684,1.1-5.295S1-4.589.878-4.589Z",
    transform: "translate(9.998 12.87)",
    fill: "#363535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_133",
    "data-name": "Line 133",
    d: "M-5.295,1.1C-5.684,1.1-6,1-6,.878V-5.773C-6-5.9-5.684-6-5.295-6s.705.1.705.227V.878C-4.589,1-4.9,1.1-5.295,1.1Z",
    transform: "translate(12.818 9.998)",
    fill: "#363535"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePlus);
export default __webpack_public_path__ + "static/media/mobile_plus.52c7daef216eab819a7e07c562843b62.svg";
export { ForwardRef as ReactComponent };